import React from 'react'
import pic from '../img/profile-2.jpg'

const About = () => {
  return (
    <about className='center'>
        <section className="about" id="about">
        <div className="max-width">
            <h2 className="title">About me</h2>
            <div className="about-content">
                <div className="column left">
                <img src={pic} alt='' />
                </div>
                <div className="column right">
                    <div className="text">I'm Indra Pal and I'm a <span className="typing-2">Ayurveda Expert</span></div>
                    <p>An incessant learner and A keen observer, Skilled in Ayurvedic Management. Always ready to help patient recover fast from their deseases.
                      <br/>
                      I have acquired knowledge of Medicine through my Degree in BAMS from Rishikul State Ayurvedic College Haridwar.
                    </p>
                    <a href="/clinic">My Clinic</a>
                </div>
            </div>
        </div>
    </section>
    </about>
  )
}

export default About